import React, { memo } from 'react';
import './Filters/Filters.css';
import MultipleSelect from './MultipleSelect';
import { useCIHAFiltersContext } from './Filters/hooks/useCIHAFiltersContext';

const UnityFilter = ({ className = '' }) => {
    const { filters, unities, onFilterChange } = useCIHAFiltersContext();

    return (
        <div className={`filtros-container-dashboards ${className}`}>
            <MultipleSelect
                label="Unidade"
                options={unities}
                onChange={onFilterChange}
                name="unidade"
                className="select-unidade-dashboards"
                defaultValue={filters.unidade}
            />
        </div>
    );
};

export default memo(UnityFilter);
